import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import EventEmitter from '../../utils/events'

// Actions
import { getInsuranceCompanies } from '../../actions/insurancecompanies'

// import styles
import './insurancecompanylist.scss'

// import components
import Header from '../../shared/components/Header'
// import LeftMenu from '../../shared/components/Menus/LeftMenu'
import LeftMenuContent from '../../shared/components/Menus/LeftMenu/Content'

// Elements
import Button from '../../shared/elements/button'
import SideMenu from '../../shared/elements/sideMenu'
import SideMenuItem from '../../shared/elements/sideMenuItem'
import SideMenuCustomItem from '../../shared/elements/sideMenuCustomItem'

// Views
import View from './View'

// Utils
import { hasAccess } from '../../utils/auth'
import { translation } from '../../utils/helpers'

class InsuranceCompanyList extends Component {

  constructor (props) {
    super(props)
    this.state = {
      view: 'list',
      insuranceCompanies: [],
      activeItem: {}
    }
    this.headerButtonsRight = this.headerButtonsRight.bind(this)
    this.createView = this.createView.bind(this)
    this.renderView = this.renderView.bind(this)
    this.onSave = this.onSave.bind(this)
    this.onSelectItem = this.onSelectItem.bind(this)
  }

  componentDidMount () {
    this.getInsuranceCompanies()
  }

  getInsuranceCompanies () {
    this.props.getInsuranceCompanies().then((res) => {
      this.setState({
        insuranceCompanies: res.data.Item2
      })
      if (res.data.Item2.length === 0) {
        this.changeView('create')
      }
    }, () => {
      console.log('err')
    })
  }

  changeView (view) {
    let activeItem = this.state.activeItem
    if (view === 'create') {
      activeItem = {}
    }
    this.setState({
      view: view,
      activeItem: activeItem
    })
  }

  headerButtonsRight () {
    if (this.state.view === 'create' || !hasAccess([2], this.props.auth.user.UserType)) return null
    return (
      <div>
        <Button spacing='0' size='m' ariaText={translation('1797')} labelText={translation(1797)} onClick={this.changeView.bind(this, 'create')} />
      </div>
    )
  }

  createView () {
    // If view is create
    if (this.state.view === 'create') {
      const onAdd = () => {
        this.refs.view.getWrappedInstance().addInsuranceCompany()
      }

      return [
        <SideMenuCustomItem key='0' isFixed>
          <Button onClick={onAdd} labelText={translation('1208')} />
        </SideMenuCustomItem>,
        <SideMenuCustomItem key='1' isFixed>
          <Button style='secondary' onClick={this.changeView.bind(this, 'list')} labelText={translation('570')} />
        </SideMenuCustomItem>
      ]
    }

    return this.state.insuranceCompanies.map(ic => {
      return (
        <SideMenuItem
          label={ic.Company}
          onClick={() => this.onSelectItem(ic)}
          selected={ic.InsuranceCompanyId === this.state.activeItem.InsuranceCompanyId}
          inactive={!ic.Active}
          key={ic.InsuranceCompanyId}
        />
      )
    })
  }

  onSave (data, type) {
    let insuranceCompanies = [...this.state.insuranceCompanies]
    let activeItem
    if (type === 'create') {
      insuranceCompanies.push({
        InsuranceCompanyId: data.InsuranceCompanyId,
        Code: data.Code,
        Name: data.Name,
        Company: data.Company,
        Active: data.Active,
        Comment: data.Comment,
        Debtor: data.Debtor
      })
      type = 'item'
      activeItem = {
        InsuranceCompanyId: data.InsuranceCompanyId
      }
    } else {
      insuranceCompanies.map((val, key) => {
        if (val.InsuranceCompanyId === data.InsuranceCompanyId) {
          val.Name = data.Name
          val.Active = data.Active
        }
      })
      type = 'item'
    }
    this.setState({
      insuranceCompanies: insuranceCompanies,
      view: type,
      activeItem: activeItem
    })
    // Toastr
    // window.toastr.success(translation('512'), translation('13424'))
  }

  renderView () {
    switch (this.state.view) {
      case 'list':
        return <div />
      case 'create':
      case 'item':
        return <View ref='view' item={this.state.activeItem} onSave={this.onSave} />
    }
  }

  onSelectItem (item) {
    this.setState({
      view: 'item',
      activeItem: item
    })
    EventEmitter.emit('sidebar_trigger', false)
  }

  render () {
    return (
      <div className='customers__screen'>
        <Header router={this.props.router} renderRight={this.headerButtonsRight} />

        {/* <LeftMenu showFilter items={this.state.insuranceCompanies} idField={'InsuranceCompanyId'} showField={'Company'} onSelectItem={this.onSelectItem} selectedItem={this.state.activeItem} view={this.state.view} onRenderCreate={this.createView} /> */}
        <SideMenu showFilter={this.state.view !== 'create'} hideInactiveCheck={this.state.view === 'create'}>
          {this.createView()}
        </SideMenu>

        <LeftMenuContent className='customers__screen--inner'>
          {this.renderView()}
        </LeftMenuContent>
      </div>
    )
  }

}

InsuranceCompanyList.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, { getInsuranceCompanies })(InsuranceCompanyList)



// WEBPACK FOOTER //
// ./src/app/pages/InsuranceCompanyList/index.js